export const validNationalId = (meliCode)=> {
    
    if (meliCode.length !== 10) {
      return false;
    }
  
    if (
      meliCode === "1111111111" ||
      meliCode === "0000000000" ||
      meliCode === "2222222222" ||
      meliCode === "3333333333" ||
      meliCode === "4444444444" ||
      meliCode === "5555555555" ||
      meliCode === "6666666666" ||
      meliCode === "7777777777" ||
      meliCode === "8888888888" ||
      meliCode === "9999999999"
    ) {
      return false;
    }
  
    let c = parseInt(meliCode.charAt(9));
    let n =
      parseInt(meliCode.charAt(0)) * 10 +
      parseInt(meliCode.charAt(1)) * 9 +
      parseInt(meliCode.charAt(2)) * 8 +
      parseInt(meliCode.charAt(3)) * 7 +
      parseInt(meliCode.charAt(4)) * 6 +
      parseInt(meliCode.charAt(5)) * 5 +
      parseInt(meliCode.charAt(6)) * 4 +
      parseInt(meliCode.charAt(7)) * 3 +
      parseInt(meliCode.charAt(8)) * 2;
    let r = n - parseInt(n / 11) * 11;
    
    return (r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r);
  }